import { render, staticRenderFns } from "./CircleStopStrokeIcon.vue?vue&type=template&id=feefd216&"
import script from "./CircleStopStrokeIcon.vue?vue&type=script&lang=js&"
export * from "./CircleStopStrokeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports